<template>
  <!-- 缺省页 -->
  <div class="nobox" :style="{height,'padding-top': paddingTop,'padding-bottom': paddingBottom}">
    <!-- <img :src="url" alt="" /> -->
    <div class="desc">{{ desc }}</div>
  </div>
</template>

<script>
export default {
  name: 'EXNodata',
  props: {
    height:{
        type: String,
        default: '100%'
    },
    paddingTop:{
        type: String,
        default: '20px'
    },
    imgName: {
      type: String,
      default: "noData",
    },
    desc: {
      type: String,
      default: "暂无数据",
    },
    paddingBottom:{
        type: String,
        default: '20px'
    },
  },
  computed: {
    url() {
    //   return require(`@/assets/404_images/${this.imgName}.png`);
    },
  },
};
</script>

<style lang="scss" scoped>
.nobox {
  text-align: center;
  img {
    display: inline-block;
    width: 173px;
    height: 90px;
  }
  .desc {
    height: 12px;
    line-height: 12px;
    // font-size: .16rem;
    font-family: SourceHanSansCN-Regular;
    line-height: 0px;
    color: rgba(0, 0, 0, 0.25);
    margin-top: 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/EXNodata/index.vue